import type { PurchaseSettlementStatus } from "@/interfaces/purchases";

/**
 * The derived settlement status, as chips. `clearing` is the one that matters operationally: the
 * card cleared and the credits are live, but Stripe's payout hasn't reached GFG's bank.
 */
export const PURCHASE_STATUS_CHIP: Record<
  PurchaseSettlementStatus,
  { label: string; color: "default" | "info" | "success" | "warning" | "error" }
> = {
  pending: { label: "Pending", color: "default" },
  clearing: { label: "Clearing", color: "warning" },
  paid: { label: "Paid", color: "success" },
  cancelled: { label: "Cancelled", color: "default" },
  failed: { label: "Failed", color: "error" },
};

export const PURCHASE_STATUS_OPTIONS: { value: PurchaseSettlementStatus; label: string }[] = [
  { value: "clearing", label: "Clearing" },
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
  { value: "failed", label: "Failed" },
  { value: "cancelled", label: "Cancelled" },
];
